import { SlugEntityAdminApiService } from './slugEntityAdminApiService';
import { Video } from '@models/video';
import { httpGet } from './apiService';
import { getLanguageByCode } from '@helpers/languages';
import { FeatureCardSelectItem } from '@models/section/featureCardSection';

export class VideoAdminService extends SlugEntityAdminApiService<Video> {
    constructor() {
        super('/api/admin/video');
    }

    public async getAllVideos(): Promise<Video[]> {
        const response = await httpGet(this.baseUrl);
        return this.returnArrayResult(await response.json());
    }

    public getFeaturedCardSelectItems = async (languageCode: string): Promise<FeatureCardSelectItem[]> => {
        const languageId = getLanguageByCode(languageCode)?.id || 1;
        return (await this.getAll(languageId)).map((video) => ({
            content: video.title,
            value: video.id,
        }));
    };
}
